import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/characterSelection.css";
import useTranslation from "../hooks/useTranslation";

function CharacterSelection({ selectedCharacters: savedCharacters, setSelectedCharacters: saveCharacters, updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  // Estado para rastrear qué personajes están seleccionados
  const [selectedCharacters, setSelectedCharacters] = useState(savedCharacters?.playersObject || {});
  const [playerCount, setPlayerCount] = useState(savedCharacters?.totalPlayers || 0);

  const characters = [
    {
      id: 'mep',
      name: t('characterSelection.characters.mep.name'),
      description: t('characterSelection.characters.mep.description'),
      image: require("../assets/people/AVATAR-05 MEP.png"),
      color: '#4CAF50' // Verde
    },
    {
      id: 'lobbyist',
      name: t('characterSelection.characters.lobbyist.name'),
      description: t('characterSelection.characters.lobbyist.description'),
      image: require("../assets/people/AVATAR-04 Industry lobbyist.png"),
      color: '#8B4513' // Marrón
    },
    {
      id: 'activist',
      name: t('characterSelection.characters.activist.name'),
      description: t('characterSelection.characters.activist.description'),
      image: require("../assets/people/AVATAR-01 yong climate activist.png"),
      color: '#ffbf00' // Amarillo
    },
    {
      id: 'mayor',
      name: t('characterSelection.characters.mayor.name'),
      description: t('characterSelection.characters.mayor.description'),
      image: require("../assets/people/AVATAR-02 Local Mayor.png"),
      color: '#2196F3' // Azul
    },
    {
      id: 'leader',
      name: t('characterSelection.characters.leader.name'),
      description: t('characterSelection.characters.leader.description'),
      image: require("../assets/people/AVATAR-06 NGO Leader.png"),
      color: '#F44336' // Rojo
    },
    {
      id: 'scientist',
      name: t('characterSelection.characters.scientist.name'),
      description: t('characterSelection.characters.scientist.description'),
      image: require("../assets/people/AVATAR-03 scientist.png"),
      color: '#9C27B0' // Morado
    }
  ];

  const handleCharacterSelect = (characterId) => {
    const character = characters.find(c => c.id === characterId);
    
    if (selectedCharacters[characterId]) {
      // Si ya está seleccionado, deseleccionarlo
      const newSelected = { ...selectedCharacters };
      delete newSelected[characterId];
      setSelectedCharacters(newSelected);
      setPlayerCount(playerCount - 1);
    } else {
      // Seleccionarlo con toda la información del jugador
      const newPlayerNumber = playerCount + 1;
      setSelectedCharacters({
        ...selectedCharacters,
        [characterId]: {
          characterId: characterId,
          name: character.name,
          description: character.description,
          color: character.color,
          image: character.image,
          playerNumber: newPlayerNumber,
          turnOrder: Object.keys(selectedCharacters).length, // Posición en el orden de turnos
          answers: [], // Array para guardar las respuestas de cada pregunta
          score: 0, // Puntuación del jugador
          isActive: false // Si es el turno actual de este jugador
        }
      });
      setPlayerCount(newPlayerNumber);
    }
  };

  const handleContinue = () => {
    if (Object.keys(selectedCharacters).length >= 4) {
      // Convertir a array ordenado por turnOrder para facilitar el manejo de turnos
      const playersArray = Object.values(selectedCharacters).sort((a, b) => a.turnOrder - b.turnOrder);
      
      // Guardar datos
      const gameData = {
        playersObject: selectedCharacters,
        playersArray: playersArray,
        totalPlayers: Object.keys(selectedCharacters).length
      };
      
      saveCharacters(gameData);
      updateProgress('character-selection');
      
      console.log('=== DATOS DEL JUEGO ===');
      console.log('Total de jugadores:', gameData.totalPlayers);
      console.log('Jugadores (Array ordenado):', gameData.playersArray);
      console.log('========================');
      
      navigate('/player-data-form');
    }
  };

  return (
    <div className="character-selection-container">
      {/* Sección de información */}
      <div className="info-section">
        <h1 className="main-title">{t('characterSelection.title')}</h1>
        <div className="info-text">
          <p>
            {t('characterSelection.infoText1')}
          </p>
          <p>
            {t('characterSelection.infoText2')}
          </p>
          <p>
            {t('characterSelection.infoText3')}
          </p>
        </div>
      </div>

      {/* Grid de personajes */}
      <div className="characters-grid">
        {characters.map((character) => {
          const playerData = selectedCharacters[character.id];
          const isSelected = !!playerData;
          
          // Color de fondo: gris oscuro si no está seleccionado, color del personaje si está seleccionado
          const backgroundColor = isSelected ? character.color : '#9E9E9E';
          
          return (
            <div
              key={character.id}
              className={`character-card ${isSelected ? 'selected' : ''}`}
            >
              <div 
                className="character-card-top"
                style={{ backgroundColor: backgroundColor }}
              >
                <div className="character-image-wrapper">
                  <img 
                    src={character.image} 
                    alt={character.name}
                    className="character-image"
                  />
                </div>
              </div>
              <div className="character-card-bottom">
                <h3 
                  className="character-name"
                  style={{ color: character.color }}
                >
                  {character.name}
                </h3>
                <p className="character-description">{character.description}</p>
                <button 
                  className="select-button"
                  style={{ backgroundColor: backgroundColor }}
                  onClick={() => handleCharacterSelect(character.id)}
                >
                  {isSelected ? t('characterSelection.selectedButton') : t('characterSelection.selectButton')}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Botón Continue */}
      <div className="continue-section">
        <button 
          className="continue-button-char"
          onClick={handleContinue}
          disabled={Object.keys(selectedCharacters).length < 4}
        >
          {t('characterSelection.continueButton')}
        </button>
      </div>
    </div>
  );
}

export default CharacterSelection;

